import React, { useEffect, useState } from 'react';
import { Card, Form, Input, Button, Typography, Space, message, Radio } from 'antd';
import ReportsLayout from './ReportsLayout';
import { scopedKey, getActiveAccountId } from '../utils/accountSession';

const { Title, Text } = Typography;
const defaultSettings = { endpoint: '', index: '', apiKey: '', authType: 'apiKey', username: '', password: '' };

const ReportsSettings = () => {
  const [settings, setSettings] = useState(defaultSettings);
  const [form] = Form.useForm();

  useEffect(() => {
    try {
      const s = JSON.parse(localStorage.getItem(scopedKey('reports_settings', getActiveAccountId())) || '{}');
      if (s && typeof s === 'object') {
        setSettings({ ...defaultSettings, ...s });
        form.setFieldsValue({ ...defaultSettings, ...s });
      }
    } catch (err) {
      // ignore
    }
  }, [form]);

  const saveSettings = (values) => {
    const updated = { ...defaultSettings, ...values };
    setSettings(updated);
    localStorage.setItem(scopedKey('reports_settings', getActiveAccountId()), JSON.stringify(updated));
    message.success('Settings saved');
  };

  return (
    <ReportsLayout>
      <Space direction="vertical" style={{ width: '100%' }} size="large">
        <Title level={4}>Report Settings</Title>
        <Text type="secondary">Configure Elasticsearch connection for all reports.</Text>
        <Card className="shadow-sm" title="Elasticsearch">
          <Form layout="vertical" form={form} initialValues={settings} onFinish={saveSettings}>
            <Form.Item name="endpoint" label="Endpoint (URL)" rules={[{ required: true, message: 'Endpoint required' }]}>
              <Input placeholder="https://your-elastic-endpoint" />
            </Form.Item>
            <Form.Item name="index" label="Default Index" rules={[{ required: true, message: 'Index required' }]}>
              <Input placeholder="logs-*" />
            </Form.Item>
            <Form.Item name="authType" label="Auth Type" initialValue="apiKey">
              <Radio.Group>
                <Radio value="apiKey">API Key</Radio>
                <Radio value="basic">Username / Password</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item
              noStyle
              shouldUpdate={(prev, cur) => prev.authType !== cur.authType}
            >
              {({ getFieldValue }) => {
                const mode = getFieldValue('authType') || 'apiKey';
                if (mode === 'basic') {
                  return (
                    <>
                      <Form.Item name="username" label="Username" rules={[{ required: true, message: 'Username required' }]}>
                        <Input placeholder="elastic" />
                      </Form.Item>
                      <Form.Item name="password" label="Password" rules={[{ required: true, message: 'Password required' }]}>
                        <Input.Password placeholder="Password" />
                      </Form.Item>
                    </>
                  );
                }
                return (
                  <Form.Item name="apiKey" label="API Key" rules={[{ required: true, message: 'API key required' }]}>
                    <Input.Password placeholder="Elastic API key" />
                  </Form.Item>
                );
              }}
            </Form.Item>
            <Space>
              <Button type="primary" htmlType="submit">
                Save
              </Button>
              <Button
                onClick={() => {
                  form.resetFields();
                  setSettings(defaultSettings);
                  localStorage.setItem(scopedKey('reports_settings', getActiveAccountId()), JSON.stringify(defaultSettings));
                }}
              >
                Reset
              </Button>
            </Space>
          </Form>
        </Card>
      </Space>
    </ReportsLayout>
  );
};

export default ReportsSettings;

